module.exports = __webpack_public_path__ + "img/project-pin.ed27a839.svg";